import { PortalThemeConfig } from '../models/portal-theme.model';

/**
 * Consignor Portal theme -- consumer-facing.
 * Dark blue sidebar with white text, sky blue accent, soft blue page background.
 */
export const CONSIGNOR_THEME: PortalThemeConfig = {
  id: 'consignor',
  label: 'Consignor Portal',
  logoPath: 'assets/applogos/brijjlogo.svg',
  tokens: {
    '--portal-accent': '#0EA5E9',
    '--portal-accent-light': 'rgba(14, 165, 233, 0.12)',
    '--portal-sidebar-bg': 'var(--primary)',
    '--portal-sidebar-text': '#FFFFFF',
    '--portal-sidebar-text-muted': 'rgba(255, 255, 255, 0.85)',
    '--portal-sidebar-section': 'rgba(255, 255, 255, 0.50)',
    '--portal-sidebar-border': 'rgba(255, 255, 255, 0.12)',
    '--portal-sidebar-active-bg': 'rgba(255, 255, 255, 0.15)',
    '--portal-sidebar-active-text': '#FFFFFF',
    '--portal-toolbar-bg': '#FFFFFF',
    '--portal-page-bg': '#F0F9FF',
    '--portal-highlight': '#0EA5E9',
    '--portal-highlight-light': 'rgba(14, 165, 233, 0.08)'
  }
};

export const PORTAL_THEMES: Record<string, PortalThemeConfig> = {
  consignor: CONSIGNOR_THEME
};
